// extracted by mini-css-extract-plugin
export default {"tableRef":"TransactionsReport_tableRef__MSzRV","textLink":"TransactionsReport_textLink__fXLLF","table":"TransactionsReport_table__tKmho"};